export default __webpack_public_path__ + "static/media/Tahmina_Watson_AHV_In_Moms_We_Trust.6398ea69.jpg";